import React from 'react';
import { cn } from '@/utils/cn';

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

export const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentStep,
  totalSteps,
  className
}) => {
  // Calculate progress percentage
  const progressPercentage = Math.min(100, Math.round((currentStep / totalSteps) * 100));
  
  return (
    <div className={cn('w-full', className)}>
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-700">
          Progression
        </span>
        <span className="text-sm text-gray-500">
          {progressPercentage}% ({currentStep}/{totalSteps})
        </span>
      </div>
      
      <div className="relative">
        {/* Background track */}
        <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
          {/* Progress bar */}
          <div
            className="h-full bg-blue-600 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        
        {/* Step markers */}
        <div className="absolute top-0 left-0 w-full flex justify-between px-1 -mt-1">
          {Array.from({ length: totalSteps }).map((_, index) => {
            const isCompleted = index + 1 <= currentStep;
            const isCurrent = index + 1 === currentStep;
            
            return (
              <div
                key={index}
                className={cn(
                  'w-4 h-4 rounded-full border-2 transition-all duration-200',
                  isCompleted ? 'bg-blue-600 border-blue-600' : 'bg-white border-gray-300',
                  isCurrent && 'ring-2 ring-blue-300'
                )}
              />
            );
          })}
        </div>
      </div>
      
      {/* Step labels */}
      <div className="flex justify-between mt-4">
        <div className="text-xs font-medium text-gray-700">
          Questions
        </div>
        <div className="text-xs font-medium text-gray-700">
          Résumé
        </div>
        <div className="text-xs font-medium text-gray-700">
          Recommandations
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;